import { Modal } from 'antd';
import { t } from '../../i18n/i18n';
import './PaymentResultDialog.scss';

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

/**
 * What each checkout return address says — the old dashboard's
 * `/evaluation/payment/<result>/` pages, which the payment processor still
 * sends the trader back to. English here, translated where rendered.
 */
export const PAYMENT_RESULTS = {
  success: {
    tone: 'success',
    icon: 'check-sm',
    title: 'Payment successful',
    body: 'Thank you. We are setting up your new trading account.',
  },
  failed: {
    tone: 'danger',
    icon: 'x-sm',
    title: 'Payment failed',
    body: 'Your payment did not go through. Please try again or use another payment method.',
  },
  cancelled: {
    tone: 'danger',
    icon: 'x-sm',
    title: 'Payment cancelled',
    body: 'The payment was cancelled before it was completed.',
  },
};

/** The result of a checkout, shown over Payment History, where the trader lands. */
export default function PaymentResultDialog({ result, onClose }) {
  const content = PAYMENT_RESULTS[result];

  return (
    <Modal
      open={Boolean(content)}
      onCancel={onClose}
      footer={null}
      centered
      width={392}
      destroyOnHidden
      className="payment-result"
      rootClassName="payment-result-root"
      aria-label={content ? t(content.title) : undefined}
    >
      {content && (
        <div className={`payment-result__body payment-result__body--${content.tone}`}>
          <span className="payment-result__badge" aria-hidden="true">
            <span className="payment-result__badge-icon" style={icon(content.icon)} />
          </span>
          <div className="payment-result__head">
            <h2 className="payment-result__title">{t(content.title)}</h2>
            <p className="payment-result__desc">{t(content.body)}</p>
          </div>
          <button type="button" className="payment-result__action" onClick={onClose}>
            {t('View payment history')}
          </button>
        </div>
      )}
    </Modal>
  );
}
